import "../css/common.css"
import Alpine from 'alpinejs';
import { parseStringArray } from './utils.js';
import 'htmx.org';

window.htmx = require('htmx.org');

window.Alpine = Alpine

document.addEventListener("htmx:afterOnLoad", function(event) {
  let messages = [];
  if (event.detail.xhr.getResponseHeader("X-Alert-Message")) {
    messages = parseStringArray(event.detail.xhr.getResponseHeader("X-Alert-Message")) || [];
  }
  const type = event.detail.xhr.getResponseHeader("X-Alert-Type") || 'success';

  if (messages.length) {
      Alpine.store('alert').trigger(messages, type);
  }
});

document.addEventListener('alpine:init', () => {
  Alpine.store('alert', {
    show: false,
    messages: '',
    type: 'success',
    timeout: null,
    trigger(messages, t = 'success') {
      this.messages = messages;
      this.type = t;
      this.show = true;
      this.timeout = setTimeout(() => this.show = false, 5000);
    },
    close() {
      console.log("Closing alert");
      this.show = false;
      clearTimeout(this.timeout);
    }
  });
});

Alpine.start()
